module.exports = __webpack_public_path__ + "static/media/horizontal.b6db9c76.svg";